/* ============================================================
   Immofiles Form v8 — JavaScript
   ============================================================
   Drop-in script for immofiles-form-v8.liquid + immofiles-form-v8.css.
   No external dependencies (no Flatpickr); custom datepicker bundled.
   ============================================================ */

(function () {
  if (window.immofilesBannerV9Initialized) return;
  window.immofilesBannerV9Initialized = true;

  /* =============================================================
     DEBUG LOGGER — production-silent unless window.IMMOFILES_DEBUG = true
     ============================================================= */
  var logger = {
    log: function(){ if(window.IMMOFILES_DEBUG) console.log.apply(console, arguments); },
    warn: function(){ if(window.IMMOFILES_DEBUG) console.warn.apply(console, arguments); },
    error: function(){ if(window.IMMOFILES_DEBUG) console.error.apply(console, arguments); }
  };

  /* =============================================================
     INLINE NOTIFICATION — replaces alert() for non-blocking UX
     ============================================================= */
  function showCartError(message){
    // Remove any previous error
    var existing = document.querySelector('.im-cart-error');
    if(existing) existing.parentNode.removeChild(existing);

    var cartActions = document.querySelector('.im-cart-actions');
    if(!cartActions){
      // Fallback: log only, can't show inline
      logger.error('[Immofiles] cart error (no UI target):', message);
      return;
    }
    var box = document.createElement('div');
    box.className = 'im-cart-error';
    box.setAttribute('role', 'alert');
    box.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg><span></span>';
    box.querySelector('span').textContent = message;
    cartActions.appendChild(box);
    // Auto-remove after 6 seconds
    setTimeout(function(){
      if(box.parentNode) box.parentNode.removeChild(box);
    }, 6000);
  }

  /* =============================================================
     CONFIG / CONSTANTS
     ============================================================= */
  // Alle 16 Bundesländer sind bestellbar. Bayern + Hessen: elektronischer
  // Abruf, Versand noch am selben Tag, Blattnummer optional. Alle übrigen
  // 14 Länder: Blattnummer ist Pflicht, Lieferzeit 1–2 Werktage (Mo–Fr),
  // Express-Lieferung noch am selben Tag zubuchbar — dafür muss die
  // Bestellung bis 16 Uhr eingehen.
  var ALLOWED_STATES = [
    'Baden-Württemberg','Bayern','Berlin','Brandenburg','Bremen','Hamburg',
    'Hessen','Mecklenburg-Vorpommern','Niedersachsen','Nordrhein-Westfalen',
    'Rheinland-Pfalz','Saarland','Sachsen','Sachsen-Anhalt',
    'Schleswig-Holstein','Thüringen'
  ];
  var INSTANT_STATES = ['Bayern','Hessen'];
  function isInstantState(st){ return INSTANT_STATES.indexOf(st) !== -1; }
  function needsBlatt(st){ return !!st && !isInstantState(st); }
  var MONTHS_DE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var WEEKDAYS_DE = ['Mo','Di','Mi','Do','Fr','Sa','So'];

  /* ---------- Lieferzeit-Berechnung ----------
     Der Annahmeschluss um 16 Uhr ist eine Bedingung fuer die Lieferung am
     selben Tag, kein allgemeiner Bearbeitungsstart: Der Antrag muss bis
     16 Uhr gestellt sein, damit noch am selben Tag geliefert wird. Fuer
     Standard gilt er nicht — dort zaehlen schlicht 1-2 Werktage.
     Wer die Grenze auf beides anwendet, nennt Standardkunden einen um
     einen Tag zu spaeten Termin. */
  var EXPRESS_SCHLUSS = 16;
  function isBusinessDay(d){ var w = d.getDay(); return w >= 1 && w <= 5; }
  function addBusinessDays(d, n){
    var r = new Date(d.getTime());
    while(n > 0){ r.setDate(r.getDate() + 1); if(isBusinessDay(r)) n--; }
    return r;
  }
  function today0(){ var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
  function nextBusinessDay(d){
    var r = new Date(d.getTime());
    do { r.setDate(r.getDate() + 1); } while(!isBusinessDay(r));
    return r;
  }
  // Tag, an dem der Antrag gestellt wird: heute, sonst der naechste Werktag
  function filingDay(){
    var d = today0();
    return isBusinessDay(d) ? d : nextBusinessDay(d);
  }
  function fmtShortDE(d){ return WEEKDAYS_DE[(d.getDay() + 6) % 7] + ', ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.'; }
  function deliveryRangeText(){
    var s = filingDay();
    return fmtShortDE(addBusinessDays(s, 1)) + ' – ' + fmtShortDE(addBusinessDays(s, 2));
  }
  // Lieferung am selben Tag nur, wenn heute ein Werktag ist und der
  // Annahmeschluss noch nicht erreicht wurde; sonst am naechsten Werktag.
  function expressDeliveryDay(){
    var d = today0();
    if(isBusinessDay(d) && new Date().getHours() < EXPRESS_SCHLUSS) return d;
    return nextBusinessDay(d);
  }
  function expressDeliveryText(){ return fmtShortDE(expressDeliveryDay()); }
  function expressIsToday(){
    var d = today0(), e = expressDeliveryDay();
    return e.getTime() === d.getTime();
  }

  /* =============================================================
     DATE UTILITIES
     ============================================================= */
  function pad(n){return n<10?'0'+n:''+n;}
  function fmtDE(d){return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear();}
  function parseDE(s){
    var m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec((s||'').trim());
    if(!m) return null;
    var day=+m[1], mon=+m[2]-1, year=+m[3];
    var d = new Date(year,mon,day);
    if(d.getFullYear()!==year || d.getMonth()!==mon || d.getDate()!==day) return null;
    return d;
  }
  function daysInMonth(year, month){return new Date(year, month+1, 0).getDate();}

  /* =============================================================
     CUSTOM DATEPICKER
     ============================================================= */
  var openPicker = null;

  function buildPicker(input){
    var TODAY = new Date(); TODAY.setHours(0,0,0,0);
    var THIS_YEAR = TODAY.getFullYear();

    var wrap = document.createElement('div');
    wrap.className = 'im-dp-pop';
    wrap.setAttribute('role','dialog');

    var header = document.createElement('div'); header.className='im-dp-head';
    var monthSel = document.createElement('select'); monthSel.className='im-dp-month';
    for(var i=0;i<12;i++){
      var o = document.createElement('option'); o.value=i; o.textContent=MONTHS_DE[i];
      monthSel.appendChild(o);
    }
    var yearSel = document.createElement('select'); yearSel.className='im-dp-year';
    for(var y=THIS_YEAR; y>=1900; y--){
      var oy = document.createElement('option'); oy.value=y; oy.textContent=y;
      yearSel.appendChild(oy);
    }
    header.appendChild(monthSel); header.appendChild(yearSel);

    var wkRow = document.createElement('div'); wkRow.className='im-dp-wk';
    WEEKDAYS_DE.forEach(function(w){var s=document.createElement('span');s.textContent=w;wkRow.appendChild(s);});

    var grid = document.createElement('div'); grid.className='im-dp-grid';

    wrap.appendChild(header);
    wrap.appendChild(wkRow);
    wrap.appendChild(grid);

    var view = { year: 1990, month: 0, selected: null };
    var existing = parseDE(input.value);
    if(existing){ view.year = existing.getFullYear(); view.month = existing.getMonth(); view.selected = existing; }

    function render(){
      monthSel.value = view.month;
      yearSel.value = view.year;
      grid.innerHTML = '';
      var firstDay = new Date(view.year, view.month, 1);
      var firstWeekday = (firstDay.getDay()+6)%7;
      var totalDays = daysInMonth(view.year, view.month);
      for(var i=0;i<firstWeekday;i++){
        var emp = document.createElement('span'); emp.className='im-dp-d im-dp-empty';
        grid.appendChild(emp);
      }
      for(var d=1; d<=totalDays; d++){
        var cell = document.createElement('button');
        cell.type='button';
        cell.className='im-dp-d';
        cell.textContent = d;
        var thisDate = new Date(view.year, view.month, d);
        if(thisDate > TODAY) cell.classList.add('im-dp-disabled');
        if(thisDate.getTime() === TODAY.getTime()) cell.classList.add('im-dp-today');
        if(view.selected && thisDate.getTime() === view.selected.getTime()) cell.classList.add('im-dp-sel');
        (function(date,btn){
          btn.addEventListener('mousedown', function(e){ e.preventDefault(); });
          btn.addEventListener('click', function(){
            if(btn.classList.contains('im-dp-disabled')) return;
            input.value = fmtDE(date);
            input.dispatchEvent(new Event('input', {bubbles:true}));
            input.dispatchEvent(new Event('change', {bubbles:true}));
            close();
          });
        })(thisDate, cell);
        grid.appendChild(cell);
      }
    }

    monthSel.addEventListener('change', function(){ view.month = parseInt(this.value,10); render(); });
    yearSel.addEventListener('change', function(){ view.year = parseInt(this.value,10); render(); });

    render();

    function close(){
      if(wrap.parentNode){ wrap.parentNode.removeChild(wrap); }
      document.removeEventListener('mousedown', outsideHandler, true);
      window.removeEventListener('resize', position);
      window.removeEventListener('scroll', position, true);
      openPicker = null;
    }
    function outsideHandler(e){
      if(!wrap.contains(e.target) && e.target !== input){ close(); }
    }
    function position(){
      var r = input.getBoundingClientRect();
      wrap.style.top = (r.bottom + window.scrollY + 6)+'px';
      wrap.style.left = (r.left + window.scrollX)+'px';
      var below = window.innerHeight - r.bottom;
      if(below < wrap.offsetHeight + 12 && r.top > wrap.offsetHeight + 12){
        wrap.style.top = (r.top + window.scrollY - wrap.offsetHeight - 6)+'px';
      }
    }

    document.body.appendChild(wrap);
    position();
    setTimeout(function(){
      document.addEventListener('mousedown', outsideHandler, true);
      window.addEventListener('resize', position);
      window.addEventListener('scroll', position, true);
    },0);

    wrap._close = close;
    return wrap;
  }

  function openPickerFor(input){
    if(openPicker){ openPicker._close(); }
    openPicker = buildPicker(input);
  }

  function bindDatepickers(scope){
    (scope || document).querySelectorAll('.im-date-input:not(.im-dp-bound)').forEach(function(el){
      el.classList.add('im-dp-bound');
      el.addEventListener('focus', function(){ openPickerFor(el); });
      el.addEventListener('click', function(){ openPickerFor(el); });
    });
  }

  /* =============================================================
     STATE
     ============================================================= */
  var state = {
    group: null,
    rolePriv: null,
    roleComp: null,
    roleEst: null,
    compVertretung: null,
    vollmachtStatus: null,
    erbeVm: null,
    hasAddress: true,  // false = "Mein Objekt hat keine Adresse" mode
    address: { street:'', plz:'', city:'', state:'', flurstueck:'', blattnummer:'' }
  };

  var currentStep = 1;

  /* =============================================================
     INIT — run after DOM ready
     ============================================================= */
  var nachweisLaedt = false;
  function loadNachweisSkript(){
    if(nachweisLaedt) return;
    nachweisLaedt = true;
    var p = document.createElement('script');
    p.src = window.__immofilesNachweisUrl;
    document.head.appendChild(p);
  }

  function init(){
    var banner = document.querySelector('.im-banner');
    if(!banner) return;

    /* ---------- Hero search ---------- */
    var searchInput = document.getElementById('im-search-input');
    var searchBtn = document.getElementById('im-search-btn');
    var autocomplete = document.getElementById('im-autocomplete');

    if(searchInput){
      // Adjust placeholder for narrow screens
      function adjustPlaceholder(){
        if(window.innerWidth < 600){
          searchInput.placeholder = 'Adresse eingeben…';
        } else {
          searchInput.placeholder = 'Adresse des Grundstücks eingeben…';
        }
      }
      adjustPlaceholder();
      window.addEventListener('resize', adjustPlaceholder);

      var mapsLoading = false;
      function loadGoogleMaps(){
        if(window.google && window.google.maps && window.google.maps.places) return;
        if(mapsLoading) return;
        mapsLoading = true;
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZlfJ4NF3zlqedqMlRIJ0Zo02vCsDs48k&libraries=places&callback=__immofilesMapsReady';
        s.async = true;
        window.__immofilesMapsReady = function(){ initGoogleAutocomplete(); };
        document.head.appendChild(s);
      }

      searchInput.addEventListener('focus', function(){ loadGoogleMaps(); });
      searchInput.addEventListener('input', function(){
        if(!window.google || !window.google.maps || !window.google.maps.places){
          if(autocomplete) autocomplete.classList.remove('im-open');
        }
      });
    }

    if(searchBtn){
      searchBtn.addEventListener('click', function(){
        if(searchInput && searchInput.value.trim().length > 2){
          // If Maps not loaded, fall back to opening wizard with manual entry
          tryEnterWizard();
        }
      });
    }

    document.addEventListener('click', function(e){
      if(autocomplete && !autocomplete.contains(e.target) && e.target !== searchInput){
        autocomplete.classList.remove('im-open');
      }
    });

    /* ---------- Google Maps Autocomplete ---------- */
    function initGoogleAutocomplete(){
      if(!window.google || !window.google.maps || !window.google.maps.places || !searchInput) return;
      var ac = new google.maps.places.Autocomplete(searchInput, {
        types: ['address'],
        componentRestrictions: { country: 'de' }
      });
      ac.addListener('place_changed', function(){
        var place = ac.getPlace();
        if(!place || !place.address_components) return;
        var street='', num='', plz='', city='', stateName='';
        place.address_components.forEach(function(c){
          if(c.types.indexOf('route')>-1) street = c.long_name;
          if(c.types.indexOf('street_number')>-1) num = c.long_name;
          if(c.types.indexOf('postal_code')>-1) plz = c.long_name;
          if(c.types.indexOf('locality')>-1) city = c.long_name;
          if(c.types.indexOf('administrative_area_level_1')>-1) stateName = c.long_name;
        });
        fillAddress((street+' '+num).trim(), plz, city, stateName);
        tryEnterWizard();
      });
    }
    if(window.google && google.maps && google.maps.places){
      initGoogleAutocomplete();
    } else {
      window.addEventListener('load', function(){
        if(window.google && google.maps && google.maps.places){
          initGoogleAutocomplete();
        }
      });
    }

    function fillAddress(street, plz, city, stateName){
      var f1 = document.getElementById('im-field-street');
      var f2 = document.getElementById('im-field-plz');
      var f3 = document.getElementById('im-field-city');
      var f4 = document.getElementById('im-field-state');
      if(f1) f1.value = street;
      if(f2) f2.value = plz;
      if(f3) f3.value = city;
      if(f4 && stateName) f4.value = stateName;
      state.address.street = street;
      state.address.plz = plz;
      state.address.city = city;
      state.address.state = stateName;
      checkStateAvailability();
      syncAside();
    }

    /* ---------- Wizard entry ----------
       Alle Bundesländer sind bestellbar – der Wizard öffnet immer.
       Länderspezifische Konditionen (Blattnummer-Pflicht, 1–2 Werktage,
       Express) regelt checkStateAvailability() im Formular. */
    function tryEnterWizard(){
      flipToWizard();
      return true;
    }

    /* ---------- Bundesland-Prüfung ---------- */
    var stateField = document.getElementById('im-field-state');
    if(stateField){
      stateField.addEventListener('change', function(){
        state.address.state = stateField.value;
        checkStateAvailability();
        syncAside();
      });
    }

    /* ---------- Versand: Standard vs. Express ---------- */
    var bannerEl = document.querySelector('.im-banner');
    var STANDARD_VARIANT = bannerEl ? (bannerEl.getAttribute('data-standard-variant') || '') : '';
    var EXPRESS_VARIANT  = bannerEl ? (bannerEl.getAttribute('data-express-variant')  || '') : '';
    var STANDARD_PRICE   = (bannerEl && bannerEl.getAttribute('data-standard-price')) || '29,90 €';
    var EXPRESS_PRICE    = (bannerEl && bannerEl.getAttribute('data-express-price')) || '39,90 €';
    var shippingChoice = 'standard';

    function updateDeliveryUI(){
      var st = state.address.state;
      var instant = isInstantState(st);
      var slow = needsBlatt(st);
      // Express nur anbieten, wenn eine EIGENE Variante hinterlegt ist.
      // Gleiche ID wie Standard = Fehlkonfiguration → Kunde würde Express
      // wählen, aber den Standardpreis zahlen. Dann lieber ausblenden.
      var expressAvailable = slow && !!EXPRESS_VARIANT && EXPRESS_VARIANT !== STANDARD_VARIANT;

      // Express nur in 1-2-Werktage-Ländern anbieten; sonst auf Standard zurück
      if(!expressAvailable) shippingChoice = 'standard';
      var isExpress = shippingChoice === 'express' && expressAvailable;

      // Versand-Auswahl (Step 5) ein-/ausblenden + Datumsangaben aktualisieren
      var shipDivider = document.getElementById('im-ship-divider');
      var shipOptions = document.getElementById('im-ship-options');
      if(shipDivider){ if(expressAvailable) shipDivider.removeAttribute('hidden'); else shipDivider.setAttribute('hidden',''); }
      if(shipOptions){ if(expressAvailable) shipOptions.removeAttribute('hidden'); else shipOptions.setAttribute('hidden',''); }
      var stdDate = document.getElementById('im-ship-std-date');
      var expDate = document.getElementById('im-ship-exp-date');
      if(stdDate) stdDate.textContent = ' · vsl. ' + deliveryRangeText();
      if(expDate) expDate.textContent = ' · vsl. ' + expressDeliveryText();

      // Nach 16 Uhr und am Wochenende ist "noch am selben Tag" nicht mehr
      // erreichbar. Bliebe der Text stehen, widerspraeche er dem Datum
      // direkt daneben — und der Kunde zahlte den Aufpreis fuer eine
      // Zusage, die an diesem Tag niemand mehr einloesen kann.
      var heuteMoeglich = expressIsToday();
      var expBadge = document.getElementById('im-ship-exp-badge');
      var expLead  = document.getElementById('im-ship-exp-lead');
      if(expBadge) expBadge.textContent = heuteMoeglich ? 'Noch heute' : 'Schnellstmöglich';
      if(expLead)  expLead.textContent  = heuteMoeglich
        ? 'Lieferung noch am selben Tag'
        : 'Nächster Werktag — für Lieferung am selben Tag bis 16 Uhr bestellen';
      var stdRadio = document.querySelector('input[name="im-shipping"][value="standard"]');
      var expRadio = document.querySelector('input[name="im-shipping"][value="express"]');
      if(stdRadio) stdRadio.checked = !isExpress;
      if(expRadio) expRadio.checked = isExpress;

      // Variante im Produktformular tauschen (Express = eigene Variante, 39,90 €)
      var idInput = document.querySelector('.product-variant-id');
      if(idInput && STANDARD_VARIANT){
        idInput.value = isExpress ? EXPRESS_VARIANT : STANDARD_VARIANT;
      }

      // Preisanzeigen (Cart-Button + Aside)
      var price = isExpress ? EXPRESS_PRICE : STANDARD_PRICE;
      var cartPrice = document.getElementById('im-cart-price');
      if(cartPrice) cartPrice.textContent = price;
      var asidePrice = document.getElementById('im-aside-price-value');
      if(asidePrice) asidePrice.textContent = price;

      // Aside: Lieferzeit-Zeile
      var asideLine = document.getElementById('im-aside-delivery-line');
      var asideVal  = document.getElementById('im-aside-delivery');
      if(asideLine && asideVal){
        if(slow){
          asideLine.removeAttribute('hidden');
          asideVal.textContent = isExpress ? ('Express · vsl. ' + expressDeliveryText()) : ('1–2 Werktage · vsl. ' + deliveryRangeText());
        } else {
          asideLine.setAttribute('hidden','');
        }
      }

      // Step 5: "Was nach der Bezahlung passiert" — Versandzeile
      var ncDelivery = document.getElementById('im-nc-delivery-desc');
      if(ncDelivery){
        if(slow){
          ncDelivery.textContent = isExpress
            ? (expressIsToday()
                ? ' per E-Mail — Express, noch heute, voraussichtlich ' + expressDeliveryText()
                : ' per E-Mail — Express, voraussichtlich ' + expressDeliveryText() + ' (für Lieferung am selben Tag bis 16 Uhr bestellen)')
            : ' per E-Mail — voraussichtlich ' + deliveryRangeText() + ' (Bearbeitung Mo–Fr)';
        } else {
          ncDelivery.textContent = ' per E-Mail noch am selben Tag';
        }
      }

      // Cart-Properties
      if(st){
        setHiddenProperty('Versand', instant ? 'Digital – noch am selben Tag'
          : (isExpress ? 'Express – Lieferung noch am selben Tag (' + EXPRESS_PRICE + ')' : 'Standard (1–2 Werktage)'));
        setHiddenProperty('Voraussichtliche Zustellung', slow
          ? (isExpress ? expressDeliveryText() : deliveryRangeText()) : '');
      } else {
        setHiddenProperty('Versand', '');
        setHiddenProperty('Voraussichtliche Zustellung', '');
      }
    }

    // Radio-Auswahl Standard/Express
    document.querySelectorAll('input[name="im-shipping"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(r.checked) shippingChoice = r.value;
        updateDeliveryUI();
      });
    });

    function updateBlattRequirement(){
      // Blattnummer ist in den 1-2-Werktage-Ländern Pflicht (beide Modi)
      var lblB = document.getElementById('im-label-blatt');
      if(lblB){
        lblB.innerHTML = needsBlatt(state.address.state)
          ? 'Blattnummer *'
          : 'Blattnummer <span class="im-label-opt">(optional)</span>';
      }
    }

    function checkStateAvailability(){
      // Alle Bundesländer sind verfügbar – die Info-Box im Wizard informiert
      // nur noch über abweichende Konditionen (1–2 Werktage + Blattnummer-Pflicht).
      var v = state.address.state || '';
      var info = document.getElementById('im-state-info');
      if(info){
        if(needsBlatt(v)){
          var t = document.getElementById('im-state-info-title');
          var x = document.getElementById('im-state-info-text');
          if(t) t.textContent = 'Lieferzeit in ' + v + ': 1–2 Werktage. ';
          if(x) x.textContent = 'Lieferzeit 1–2 Werktage, Bearbeitung Mo–Fr. Die Blattnummer ist hier ein Pflichtfeld. Im letzten Schritt kannst Du Express-Lieferung noch am selben Tag zubuchen — dafür muss die Bestellung bis 16 Uhr eingehen.';
          info.removeAttribute('hidden');
        } else {
          info.setAttribute('hidden','');
        }
      }
      updateBlattRequirement();
      updateDeliveryUI();
      updateCheckoutButtonsVisibility();
      return true;
    }

    function updateCartButtonState(){
      // Alle Bundesländer sind bestellbar – kein State-basiertes Sperren mehr.
      // (AGB-/PayPal-Guard läuft separat über die im-paypal-blocked-Logik.)
      var btn = document.getElementById('im-btn-cart');
      if(btn){ btn.disabled = false; }
      var pp = document.querySelector('.im-paypal-wrap');
      if(pp){ pp.style.opacity = ''; }
    }

    // Backward-compat aliases (older code paths reference these)
    function hideCheckoutButtons(){ updateCartButtonState(); }
    function showCheckoutButtons(){ updateCartButtonState(); }
    function updateCheckoutButtonsVisibility(){ updateCartButtonState(); }

    /* ---------- Banner flip ---------- */
    function flipToWizard(){
      if(banner.classList.contains('im-locked')) return;
      // Capture height
      var h = banner.offsetHeight;
      banner.style.setProperty('--im-banner-h', h+'px');
      banner.classList.add('im-flipping');
      setTimeout(function(){
        banner.classList.remove('im-flipping');
        banner.classList.add('im-locked');
        setTimeout(function(){ banner.classList.add('im-revealed'); }, 30);
      }, 420);
      goStep(1);
      syncAside();
    }

    function resetWizard(){
      banner.classList.remove('im-locked','im-revealed');
      currentStep = 1;
      // Also reset no-address mode if active
      if(!state.hasAddress){ setHasAddressMode(true); }
    }

    var addrTag = document.getElementById('im-addr-tag');
    if(addrTag){ addrTag.addEventListener('click', resetWizard); }

    /* ---------- "Mein Objekt hat keine Adresse" mode toggle ---------- */
    function setHasAddressMode(hasAddr){
      state.hasAddress = hasAddr;
      var addrFields = document.getElementById('im-address-fields');
      var noAddrState = document.getElementById('im-no-address-state');
      var noAddrNotice = document.getElementById('im-no-address-notice');
      var hiddenInput = document.getElementById('im-field-has-address');
      var step1Sub = document.getElementById('im-step-1-sub');

      if(hasAddr){
        if(addrFields) addrFields.removeAttribute('hidden');
        if(noAddrState) noAddrState.setAttribute('hidden','');
        if(noAddrNotice) noAddrNotice.setAttribute('hidden','');
        if(hiddenInput) hiddenInput.value = 'Ja';
        if(step1Sub) step1Sub.textContent = 'Bestätige die Adresse des Grundstücks und ergänze ggf. Flurstück oder Blattnummer.';
        // Restore flurstück/blatt labels to optional
        var lblF = document.getElementById('im-label-flurstueck');
        var lblB = document.getElementById('im-label-blatt');
        if(lblF) lblF.innerHTML = 'Flurstück <span class="im-label-opt">(optional)</span>';
        if(lblB) lblB.innerHTML = 'Blattnummer <span class="im-label-opt">(optional)</span>';
        // Clear gemarkung — not relevant in address mode
        var gem = document.getElementById('im-field-gemarkung');
        if(gem){ gem.value = ''; clearError(gem); }
      } else {
        if(addrFields) addrFields.setAttribute('hidden','');
        if(noAddrState) noAddrState.removeAttribute('hidden');
        if(noAddrNotice) noAddrNotice.removeAttribute('hidden');
        if(hiddenInput) hiddenInput.value = 'Nein';
        if(step1Sub) step1Sub.textContent = 'Wähle Bundesland, Gemarkung und gib Flurstück oder Blattnummer an.';
        // Mark flurstück/blatt as conditionally required (at least one)
        var lblF2 = document.getElementById('im-label-flurstueck');
        var lblB2 = document.getElementById('im-label-blatt');
        if(lblF2) lblF2.innerHTML = 'Flurstück *';
        if(lblB2) lblB2.innerHTML = 'Blattnummer <span class="im-label-opt">(optional)</span>';
        // Clear any address-field errors (they don't apply in this mode)
        ['im-field-street','im-field-plz','im-field-city','im-field-state'].forEach(function(id){
          var el = document.getElementById(id);
          if(el){ clearError(el); }
        });
      }
      // Länderspezifische Regeln erneut anwenden (Blattnummer-Pflicht, Lieferzeit)
      checkStateAvailability();
      syncAside();
    }

    // No-address state selector — sync to hidden main state field so properties[] still goes through
    var stateFieldNoAddr = document.getElementById('im-field-state-noaddr');
    if(stateFieldNoAddr){
      stateFieldNoAddr.addEventListener('change', function(){
        state.address.state = stateFieldNoAddr.value;
        // Also write to main state field so the FormData submission includes it
        var mainState = document.getElementById('im-field-state');
        if(mainState) mainState.value = stateFieldNoAddr.value;
        checkStateAvailability();
        syncAside();
      });
    }

    var noAddrLink = document.getElementById('im-no-address-link');
    if(noAddrLink){
      noAddrLink.addEventListener('click', function(){
        // Clear any previous address
        state.address = { street:'', plz:'', city:'', state:'', flurstueck:'', blattnummer:'' };
        var f1 = document.getElementById('im-field-street');
        var f2 = document.getElementById('im-field-plz');
        var f3 = document.getElementById('im-field-city');
        var f4 = document.getElementById('im-field-state');
        if(f1) f1.value = '';
        if(f2) f2.value = '';
        if(f3) f3.value = '';
        if(f4) f4.value = '';
        setHasAddressMode(false);
        flipToWizard();
      });
    }

    /* ---------- Field listeners ---------- */
    ['im-field-street','im-field-plz','im-field-city','im-field-flurstueck','im-field-blatt'].forEach(function(id){
      var el = document.getElementById(id);
      if(!el) return;
      el.addEventListener('input', function(){
        if(id==='im-field-street') state.address.street = el.value;
        if(id==='im-field-plz') state.address.plz = el.value;
        if(id==='im-field-city') state.address.city = el.value;
        if(id==='im-field-flurstueck') state.address.flurstueck = el.value;
        if(id==='im-field-blatt') state.address.blattnummer = el.value;
        syncAside();
      });
    });

    /* Blattnummer — nur Ziffern erlauben */
    (function(){
      var blatt = document.getElementById('im-field-blatt');
      if(!blatt) return;
      blatt.addEventListener('keydown', function(e){
        var allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Tab','Home','End'];
        if(allowed.indexOf(e.key) !== -1) return;
        if(e.ctrlKey || e.metaKey) return; // Strg+C/V/A etc. durchlassen
        if(!/^[0-9]$/.test(e.key)) e.preventDefault();
      });
      blatt.addEventListener('paste', function(e){
        e.preventDefault();
        var text = (e.clipboardData || window.clipboardData).getData('text');
        var digits = text.replace(/[^0-9]/g, '');
        if(!digits) return;
        var start = blatt.selectionStart, end = blatt.selectionEnd;
        blatt.value = blatt.value.slice(0, start) + digits + blatt.value.slice(end);
        blatt.setSelectionRange(start + digits.length, start + digits.length);
        blatt.dispatchEvent(new Event('input'));
      });
    })();

    /* ---------- Step navigation ---------- */
    document.querySelectorAll('[data-action]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var act = btn.getAttribute('data-action');
        handleAction(act);
      });
    });

    function handleAction(act){
      switch(act){
        case 'next-from-1': if(validateStep1()){ goStep('2a'); } break;
        case 'next-from-2a': if(validateStep2a()){ goStep('2b'); } break;
        case 'next-from-2b': if(validateStep2b()){ if(state.group==='private'&&getEffectiveRole()==='self-owner'){ if(needsProofStep()) goStep(4); else goStep(5); } else { goStep(3); } } break;
        case 'next-from-3': if(validateStep3()){ if(needsProofStep()) goStep(4); else goStep(5); } break;
        case 'next-from-4': if(validateStep4()){ goStep(5); } break;
        case 'back-to-1': goStep(1); break;
        case 'back-to-2a': goStep('2a'); break;
        case 'back-to-2b': goStep('2b'); break;
        case 'back-to-3': if(state.group==='private'&&getEffectiveRole()==='self-owner') goStep('2b'); else goStep(3); break;
        case 'back-from-5': if(needsProofStep()) goStep(4); else if(state.group==='private'&&getEffectiveRole()==='self-owner') goStep('2b'); else goStep(3); break;
      }
    }

    /* ---------- Step 2a: Group selection ---------- */
    document.querySelectorAll('.im-qc').forEach(function(card){
      card.addEventListener('click', function(){
        document.querySelectorAll('.im-qc').forEach(function(c){ c.classList.remove('im-sel'); });
        card.classList.add('im-sel');
        var grp = card.getAttribute('data-grp');
        if(state.group !== grp){
          // Reset role state when group changes
          state.rolePriv = null;
          state.roleComp = null;
          state.roleEst = null;
          state.compVertretung = null;
          document.querySelectorAll('input[name="im-role-priv"],input[name="im-role-comp"],input[name="im-role-est"],input[name="im-comp-vertretung"]').forEach(function(r){ r.checked=false; });
          var btn2b = document.getElementById('im-btn-2b-next');
          if(btn2b) btn2b.disabled = true;
        }
        state.group = grp;
        var btn2a = document.getElementById('im-btn-2a-next');
        if(btn2a) btn2a.disabled = false;
        syncAside();
      });
    });

    /* ---------- Dinglich Berechtigte: derzeit nicht bestellbar ----------
       Die Auswahl bleibt sichtbar, führt aber zu einem Hinweis statt zur
       Bestellung. Betrifft vier Stellen: eigene Rolle (Privatperson) sowie
       die Rolle der vertretenen Person bzw. der Gesellschaft. */
    function istDinglich(wert){ return (wert || '').indexOf('Dinglich Berechtigter') !== -1; }

    function hinweisSetzen(id, sichtbar){
      var el = document.getElementById(id);
      if(el) el.classList.toggle('im-show', !!sichtbar);
    }

    function dinglichPruefen(){
      // eigene Rolle (Privatperson)
      var eigen = state.rolePriv === 'self-dinglich';
      hinweisSetzen('im-hinweis-dinglich-priv', eigen);

      // Rollen in Schritt 3 – nur prüfen, was gerade sichtbar ist
      var felder = [
        ['im-vertretener-rolle',   'im-hinweis-dinglich-vertreter'],
        ['im-comp-organ-rolle',    'im-hinweis-dinglich-organ'],
        ['im-comp-external-rolle', 'im-hinweis-dinglich-external']
      ];
      var gesperrt = eigen;
      felder.forEach(function(paar){
        var f = document.getElementById(paar[0]);
        var aktiv = f && f.offsetParent !== null && istDinglich(f.value);
        hinweisSetzen(paar[1], aktiv);
        if(aktiv) gesperrt = true;
      });

      // Weiter-Schaltflächen sperren
      var b2b = document.getElementById('im-btn-2b-next');
      if(b2b && eigen) b2b.disabled = true;
      document.querySelectorAll('[data-action="next-from-3"]').forEach(function(b){
        b.disabled = gesperrt && !eigen;
      });
      return !gesperrt;
    }
    window.immofilesDinglichPruefen = dinglichPruefen;

    ['im-vertretener-rolle','im-comp-organ-rolle','im-comp-external-rolle'].forEach(function(id){
      var f = document.getElementById(id);
      if(f) f.addEventListener('change', dinglichPruefen);
    });

    /* ---------- Step 2b: Role selection ---------- */
    document.querySelectorAll('input[name="im-role-priv"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(r.checked){
          state.rolePriv = r.value;
          // Bei "dinglich Berechtigter" bleibt der Weiter-Button gesperrt
          document.getElementById('im-btn-2b-next').disabled = (r.value === 'self-dinglich');
          dinglichPruefen();
          syncAside();
        }
      });
    });
    document.querySelectorAll('input[name="im-role-comp"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(r.checked){ state.roleComp = r.value; document.getElementById('im-btn-2b-next').disabled = false; syncAside(); }
      });
    });
    document.querySelectorAll('input[name="im-role-est"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(r.checked){ state.roleEst = r.value; document.getElementById('im-btn-2b-next').disabled = false; syncAside(); }
      });
    });
    document.querySelectorAll('input[name="im-comp-vertretung"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(r.checked){
          state.compVertretung = r.value;
          var lbl = document.getElementById('im-comp-name-label');
          if(lbl){
            if(r.value === 'single') lbl.innerHTML = 'Mein vollständiger Name <span class="im-required">*</span>';
            else lbl.innerHTML = 'Namen aller gemeinsam vertretungsberechtigten Personen <span class="im-required">*</span>';
          }
        }
      });
    });

    /* ---------- Step 3: Vertretener-Rolle Dropdown → Eigentümer-Card ---------- */
    function updateEigentuemerCard(){
      var sel = document.getElementById('im-vertretener-rolle');
      var card = document.getElementById('im-vertreter-eigentuemer-card');
      if(!sel || !card) return;
      var isDinglich = sel.value === 'Dinglich Berechtigter';
      card.classList.toggle('im-show', isDinglich);
      // Art der dinglichen Berechtigung ein-/ausblenden
      var artDiv = document.getElementById('im-vertreter-dinglich-art');
      if(artDiv) artDiv.classList.toggle('im-show', isDinglich);
      // Felder leeren wenn nicht sichtbar
      if(!isDinglich){
        card.querySelectorAll('input').forEach(function(inp){
          inp.value = '';
          var prop = inp.getAttribute('data-property');
          if(prop) setHiddenProperty(prop, '');
        });
        // Art-Dropdown leeren
        if(artDiv){
          var artSel = artDiv.querySelector('select');
          if(artSel){ artSel.value = ''; setHiddenProperty('Dinglich Berechtigter: Art der Berechtigung', ''); }
        }
      }
    }
    var vertretenerRolleSel = document.getElementById('im-vertretener-rolle');
    if(vertretenerRolleSel){
      vertretenerRolleSel.addEventListener('change', function(){
        updateEigentuemerCard();
        computeAndSetHiddenProperties();
      });
    }

    // comp-organ Grundbuchrolle → Eigentümer-Card
    function updateCompOrganEigentuemerCard(){
      var sel  = document.getElementById('im-comp-organ-rolle');
      var card = document.getElementById('im-comp-organ-eigentuemer-card');
      if(!sel || !card) return;
      var isDinglich = sel.value === 'Dinglich Berechtigter';
      card.classList.toggle('im-show', isDinglich);
      if(!isDinglich){
        card.querySelectorAll('input').forEach(function(inp){
          inp.value = '';
          var prop = inp.getAttribute('data-property');
          if(prop) setHiddenProperty(prop, '');
        });
      }
    }
    var compOrganRolleSel = document.getElementById('im-comp-organ-rolle');
    if(compOrganRolleSel){
      compOrganRolleSel.addEventListener('change', function(){
        updateCompOrganEigentuemerCard();
        computeAndSetHiddenProperties();
      });
    }

    // comp-external Grundbuchrolle → Eigentümer-Card
    function updateCompExternalEigentuemerCard(){
      var sel  = document.getElementById('im-comp-external-rolle');
      var card = document.getElementById('im-comp-external-eigentuemer-card');
      if(!sel || !card) return;
      var isDinglich = sel.value === 'Dinglich Berechtigter';
      card.classList.toggle('im-show', isDinglich);
      if(!isDinglich){
        card.querySelectorAll('input').forEach(function(inp){
          inp.value = '';
          var prop = inp.getAttribute('data-property');
          if(prop) setHiddenProperty(prop, '');
        });
      }
    }
    var compExternalRolleSel = document.getElementById('im-comp-external-rolle');
    if(compExternalRolleSel){
      compExternalRolleSel.addEventListener('change', function(){
        updateCompExternalEigentuemerCard();
        computeAndSetHiddenProperties();
      });
    }

    /* ---------- Step navigation engine ---------- */
    function goStep(n){
      currentStep = n;
      document.querySelectorAll('.im-step').forEach(function(s){ s.classList.remove('im-active'); });
      var paneId = 'im-step-'+n;
      var pane = document.getElementById(paneId);
      if(pane) pane.classList.add('im-active');

      // Toggle banner step class — used by CSS to show/hide step-5-only elements (paypal, etc.)
      var bn = document.querySelector('.im-banner');
      if(bn){
        bn.classList.remove('im-on-step-1','im-on-step-2a','im-on-step-2b','im-on-step-3','im-on-step-4','im-on-step-5');
        bn.classList.add('im-on-step-' + n);
      }

      var wbox = document.querySelector('.im-wbox');
      if(wbox) wbox.scrollTop = 0;

      try {
        if(n==='2b') updateStep2bContent();
        if(n===3) updateStep3Content();
        if(n===4){ updateStep4Content(); loadNachweisSkript(); }
        if(n===5) updateStep5Content();
      } catch(e) {
        logger.warn('[Immofiles] step update failed for step '+n+':', e);
      }

      try { updateProgressBar(); } catch(e){}
      try { updateCheckoutButtonsVisibility(); } catch(e){}

    }

    function updateStep2bContent(){
      var grp = state.group;
      document.querySelectorAll('[data-cond-role-group]').forEach(function(el){ el.classList.remove('im-show'); });
      var target = document.querySelector('[data-cond-role-group="'+grp+'"]');
      if(target) target.classList.add('im-show');

      var sub = document.getElementById('im-step-2b-sub');
      var groupLabel = '';
      if(grp==='private') groupLabel = 'Privatperson(en)';
      else if(grp==='company') groupLabel = 'Unternehmen / Verein';
      else if(grp==='estate') groupLabel = 'Verstorbene Person (Erbfall)';
      if(sub) sub.textContent = 'Eingetragen: '+groupLabel+'. Bitte wähle Deine Rolle.';

      var ct = document.getElementById('im-confirm-text');
      if(ct) ct.textContent = 'Eingetragen: '+groupLabel;

      var btn = document.getElementById('im-btn-2b-next');
      if(btn) btn.disabled = !getEffectiveRole();
    }

    function getEffectiveRole(){
      if(state.group==='private') return state.rolePriv;
      if(state.group==='company') return state.roleComp;
      if(state.group==='estate') return state.roleEst;
      return null;
    }

    function getRoleCategory(){
      // Returns a normalized category for downstream logic.
      // Note: in mockup-aligned schema, "vertreter" is the role in private/estate;
      // the with-/without-Vollmacht distinction is captured in step 4 via radio
      // (state.vollmachtStatus / state.erbeVm).
      var r = getEffectiveRole();
      if(!r) return null;
      if(state.group==='private'){
        if(r==='self-owner' || r==='self-dinglich') return 'self';
        if(r==='vertreter'){
          return 'rep-with'; // rep-without existiert nicht mehr — Vollmacht im Formular
        }
      }
      if(state.group==='company'){
        if(r==='organ') return 'organ';
        if(r==='external') return 'rep-with';
      }
      if(state.group==='estate'){
        if(r==='heir-self') return 'heir-self';
        if(r==='heir-rep'){
          return 'heir-rep-with'; // heir-rep-without existiert nicht mehr
        }
      }
      return null;
    }

    function updateStep3Content(){
      var role = getEffectiveRole();
      document.querySelectorAll('[data-data-block]').forEach(function(el){ el.classList.remove('im-show'); });
      var blockId = null;

      if(state.group==='private'){
        if(role==='self-owner') blockId='priv-self-owner';
        else if(role==='self-dinglich') blockId='priv-self-dinglich';
        else if(role==='vertreter') blockId='priv-vertreter';
      } else if(state.group==='company'){
        if(role==='organ') blockId='comp-organ';
        else if(role==='external') blockId='comp-external';
      } else if(state.group==='estate'){
        if(role==='heir-self') blockId='est-self';
        else if(role==='heir-rep') blockId='est-rep';
      }

      if(blockId){
        var b = document.querySelector('[data-data-block="'+blockId+'"]');
        if(b) b.classList.add('im-show');
      }

      var t = document.getElementById('im-step-3-title');
      var s = document.getElementById('im-step-3-sub');
      if(t && s){
        if(blockId==='priv-self-owner'){ t.textContent='Deine Daten'; s.textContent='Damit wir Dich im Grundbuch identifizieren können.'; }
        else if(blockId==='priv-self-dinglich'){ t.textContent='Deine Daten als dinglich Berechtigter'; s.textContent='Wähle die Art Deiner Berechtigung und gib Dein Geburtsdatum ein.'; }
        else if(blockId==='priv-vertreter'){ t.textContent='Daten der vertretenen Person'; s.textContent='Damit wir die Person im Grundbuch zweifelsfrei identifizieren können.'; }
        else if(blockId==='comp-organ'){ t.textContent='Daten der Gesellschaft und der Vertretung'; s.textContent='Bitte gib die Daten der eingetragenen Gesellschaft und Deine Vertretungsbefugnis ein.'; }
        else if(blockId==='comp-external'){ t.textContent='Daten der vertretenen Gesellschaft'; s.textContent='Bitte gib die Daten der Gesellschaft ein, die Du vertrittst.'; }
        else if(blockId==='est-self'){ t.textContent='Daten der verstorbenen Person'; s.textContent='Bitte gib die Daten der im Grundbuch eingetragenen verstorbenen Person ein.'; }
        else if(blockId==='est-rep'){ t.textContent='Daten zum Erben und zur verstorbenen Person'; s.textContent='Bitte gib die Daten beider Personen ein.'; }
      }

      bindDatepickers();
      updatePayPalGuardSpaeter();
      // Eigentümer-Card-Status nach Block-Wechsel aktualisieren
      updateEigentuemerCard();
      updateCompOrganEigentuemerCard();
      updateCompExternalEigentuemerCard();
    }

    function needsProofStep(){
      var cat = getRoleCategory();
      if(!cat) return false;
      // Self / organ: no proof step
      if(cat==='self' || cat==='organ') return false;
      // heir-self braucht Erbschein-Upload → Step 4 anzeigen
      // rep-with, rep-without, heir-rep-*: proof step needed
      return true;
    }

    function updateStep4Content(){
      var cat = getRoleCategory();
      document.querySelectorAll('[data-proof-block]').forEach(function(el){ el.classList.remove('im-show'); });
      var blockId = null;
      // New structure (matches mockup): three proof blocks total
      if(cat==='rep-with' || cat==='rep-without') blockId = 'vollmacht';
      else if(cat==='heir-self') blockId = 'erbe-self';
      else if(cat==='heir-rep-with' || cat==='heir-rep-without') blockId = 'erbe-rep';

      if(blockId){
        var b = document.querySelector('[data-proof-block="'+blockId+'"]');
        if(b) b.classList.add('im-show');
      }

      var t = document.getElementById('im-step-4-title');
      var s = document.getElementById('im-step-4-sub');
      if(t && s){
        if(blockId==='vollmacht'){ t.textContent='Vollmacht'; s.textContent='Hast Du eine schriftliche Vollmacht oder brauchst Du ein Muster von uns?'; }
        else if(blockId==='erbe-self'){ t.textContent='Nachweis Deiner Erbenstellung'; s.textContent='Bitte lade Deinen Erbschein oder ein notarielles Testament mit Eröffnungsprotokoll hoch.'; }
        else if(blockId==='erbe-rep'){ t.textContent='Erbschein und Vollmacht'; s.textContent='Bitte lade den Erbschein hoch und gib an, ob Du eine Vollmacht des Erben hast.'; }
      }

      // Auto-pre-select correct radio if cat already determines vollmacht-status
      if(blockId === 'vollmacht'){
        var radios = document.querySelectorAll('input[name="im-vollmacht-status"]');
        var preSel = (cat === 'rep-with') ? 'haben' : (cat === 'rep-without') ? 'brauchen' : null;
        if(preSel){
          radios.forEach(function(r){
            if(r.value === preSel){ r.checked = true; r.dispatchEvent(new Event('change', {bubbles:true})); }
          });
        }
      }
      if(blockId === 'erbe-rep'){
        var radios2 = document.querySelectorAll('input[name="im-erbe-vm"]');
        var preSel2 = (cat === 'heir-rep-with') ? 'haben' : (cat === 'heir-rep-without') ? 'brauchen' : null;
        if(preSel2){
          radios2.forEach(function(r){
            if(r.value === preSel2){ r.checked = true; r.dispatchEvent(new Event('change', {bubbles:true})); }
          });
        }
      }
    }

    // Toggle vollmacht-block visibility based on radio selection
    function bindStep4Radios(){
      document.querySelectorAll('input[name="im-vollmacht-status"]').forEach(function(r){
        r.addEventListener('change', function(){
          var v = r.value;
          state.vollmachtStatus = v;
          document.querySelectorAll('[data-vollmacht-block]').forEach(function(el){
            el.classList.toggle('im-show', el.getAttribute('data-vollmacht-block') === (v === 'haben' ? 'upload' : 'muster'));
          });
        });
      });
      document.querySelectorAll('input[name="im-erbe-vm"]').forEach(function(r){
        r.addEventListener('change', function(){
          var v = r.value;
          state.erbeVm = v;
          document.querySelectorAll('[data-erbe-vm-block]').forEach(function(el){
            el.classList.toggle('im-show', el.getAttribute('data-erbe-vm-block') === (v === 'haben' ? 'upload' : 'muster'));
          });
        });
      });
    }

    function updateStep5Content(){
      // Show/hide "second Vollmacht" stichpunkt
      var cat = getRoleCategory();
      var showSecond = (cat==='rep-without' || cat==='heir-rep-without');
      var el = document.getElementById('im-nc-second-vm');
      if(el){ if(showSecond) el.removeAttribute('hidden'); else el.setAttribute('hidden',''); }

      // Update ident-title and desc
      var identTitle = document.getElementById('im-nc-ident-title');
      var identDesc = document.getElementById('im-nc-ident-desc');
      if(identTitle && identDesc){
        var who = 'Online-Ausweisprüfung';
        var identPerson = 'Antragsteller';
        var descSuffix = ' Deines Personalausweises, Reisepasses oder Führerscheins (Datei oder Foto per Smartphone, ca. 2 Min). <a href="#" class="im-nc-info-link">Mehr Infos</a>';
        var descPrefix = ' — Du erhältst per E-Mail einen Link zum gesicherten Upload';

        if(cat==='self' || cat==='organ' || cat==='heir-self' || cat==='rep-with' || cat==='heir-rep-with'){
          identTitle.textContent = 'Online-Ausweisprüfung des Antragstellers';
          identDesc.innerHTML = descPrefix + descSuffix;
          identPerson = 'Antragsteller';
        } else if(cat==='rep-without'){
          identTitle.textContent = 'Online-Ausweisprüfung des Eingetragenen';
          identDesc.innerHTML = ' — Der Eingetragene erhält per E-Mail einen Link zum gesicherten Upload des Personalausweises, Reisepasses oder Führerscheins (Datei oder Foto per Smartphone, ca. 2 Min). <a href="#" class="im-nc-info-link">Mehr Infos</a>';
          identPerson = 'Vertretener';
        } else if(cat==='heir-rep-without'){
          identTitle.textContent = 'Online-Ausweisprüfung des Erben';
          identDesc.innerHTML = ' — Der Erbe erhält per E-Mail einen Link zum gesicherten Upload des Personalausweises, Reisepasses oder Führerscheins (Datei oder Foto per Smartphone, ca. 2 Min). <a href="#" class="im-nc-info-link">Mehr Infos</a>';
          identPerson = 'Erbe';
        }
        // Set hidden property
        setHiddenProperty('Identifikation: Person', identPerson);
      }

      initNextCardState();
      computeAndSetHiddenProperties();
    }

    /* ---------- Progress bar ---------- */
    function updateProgressBar(){
      var n = currentStep;
      var skipsProof = !needsProofStep();
      var phase, substep = 0;
      if(n===1){ phase=1; substep=0; }
      else if(n==='2a'){ phase=2; substep=0; }
      else if(n==='2b'){ phase=2; substep=0.5; }
      else if(n===3){ phase=3; substep=0; }
      else if(n===4){ phase=4; substep=0; }
      else if(n===5){ phase=5; substep=0; }
      else { phase=1; substep=0; }

      var visiblePhase = phase;
      if(skipsProof && phase===5) visiblePhase = 4;

      var pbar = document.getElementById('im-pbar');
      if(pbar){
        pbar.setAttribute('data-current', visiblePhase);
        var total = skipsProof ? 4 : 5;
        pbar.setAttribute('data-total', total);
        var prog = ((visiblePhase - 1 + substep) / (total - 1)) * 100;
        pbar.style.setProperty('--im-m-prog', Math.max(0, Math.min(100, prog)) + '%');
      }

      document.querySelectorAll('.im-pbar-step').forEach(function(el){
        var s = parseInt(el.dataset.step,10);
        el.classList.remove('im-active','im-done','im-skip','im-clickable');
        if(s===4 && skipsProof){ el.classList.add('im-skip'); return; }
        if(s < phase){ el.classList.add('im-done'); el.classList.add('im-clickable'); }
        else if(s === phase){ el.classList.add('im-active'); }
      });

      document.querySelectorAll('.im-pbar-track').forEach(function(t,i){
        var leftPhase = i + 1;
        var rightPhase = i + 2;
        var fill = t.querySelector('.im-pbar-fill');
        var connectsSkipped = skipsProof && (leftPhase === 4 || rightPhase === 4);
        t.classList.toggle('im-skip', connectsSkipped);
        var movedPastLeft = phase > leftPhase || (skipsProof && leftPhase === 4 && phase === 5);
        if(movedPastLeft){
          fill.style.width = '100%';
        } else if(phase === leftPhase && substep > 0){
          fill.style.width = (substep * 100) + '%';
        } else {
          fill.style.width = '0%';
        }
      });
    }

    // Click navigation on done bubbles
    document.querySelectorAll('.im-pbar-step').forEach(function(el){
      el.addEventListener('click', function(){
        if(!el.classList.contains('im-clickable')) return;
        var s = parseInt(el.dataset.step,10);
        if(s===2){ if(state.group) goStep('2b'); else goStep('2a'); }
        else goStep(s);
      });
    });

    /* ---------- Validation ---------- */
    // Waehrend einer stummen Pruefung wird nichts rot markiert. Der
    // PayPal-Waechter muss bei jeder Aenderung pruefen duerfen, ohne dem
    // Kunden Fehler an Feldern anzuzeigen, die er noch gar nicht gesehen hat.
    var pruefungStumm = false;

    function clearError(input){
      if(pruefungStumm) return;
      if(!input) return;
      input.classList.remove('im-error');
      var fg = input.closest('.im-fg');
      if(fg){
        var err = fg.querySelector('.im-field-error');
        if(err) err.parentNode.removeChild(err);
      }
    }
    function setError(input, msg){
      if(pruefungStumm) return;
      if(!input) return;
      input.classList.add('im-error');
      var fg = input.closest('.im-fg');
      if(fg && !fg.querySelector('.im-field-error')){
        var div = document.createElement('div');
        div.className = 'im-field-error';
        div.textContent = msg;
        fg.appendChild(div);
      }
    }

    function validateStep1(){
      var ok = true;

      // Always clear all step-1 field errors first
      ['im-field-street','im-field-plz','im-field-city','im-field-state','im-field-state-noaddr','im-field-gemarkung','im-field-flurstueck','im-field-blatt'].forEach(function(id){
        var f = document.getElementById(id);
        if(f) clearError(f);
      });

      if(state.hasAddress){
        // Standard address mode: street, plz, city, state are required
        var streetEl = document.getElementById('im-field-street');
        if(!streetEl || !streetEl.value.trim()){
          setError(streetEl, 'Bitte Straße und Hausnummer angeben.');
          ok = false;
        } else if(!/\d/.test(streetEl.value)){
          // Hausnummer-Validierung: Straßenfeld muss eine Ziffer enthalten
          setError(streetEl, 'Bitte auch die Hausnummer angeben (z. B. Musterstraße 12).');
          ok = false;
        }

        ['im-field-plz','im-field-city','im-field-state'].forEach(function(id){
          var f = document.getElementById(id);
          if(!f || !f.value.trim()){ setError(f, 'Pflichtfeld'); ok = false; }
        });

        checkStateAvailability();
      } else {
        // No-address mode: Bundesland + Gemarkung are required; Flurstück ist Pflicht
        var stateSel = document.getElementById('im-field-state-noaddr');
        if(!stateSel || !stateSel.value.trim()){
          setError(stateSel, 'Pflichtfeld');
          ok = false;
        }

        var gemarkungEl = document.getElementById('im-field-gemarkung');
        if(!gemarkungEl || !gemarkungEl.value.trim()){
          setError(gemarkungEl, 'Pflichtfeld');
          ok = false;
        }

        var flurstueck = document.getElementById('im-field-flurstueck');
        if(!flurstueck || !flurstueck.value.trim()){
          setError(flurstueck, 'Pflichtfeld');
          ok = false;
        }
      }

      // Blattnummer: Pflicht in allen Ländern außer Bayern und Hessen (beide Modi)
      if(needsBlatt(state.address.state)){
        var blattEl = document.getElementById('im-field-blatt');
        if(!blattEl || !blattEl.value.trim()){
          setError(blattEl, 'In ' + state.address.state + ' ist die Blattnummer erforderlich. Du findest sie auf alten Auszügen, im Kaufvertrag oder in Finanzierungsunterlagen.');
          ok = false;
        }
      }

      return ok;
    }
    function validateStep2a(){
      return !!state.group;
    }
    function validateStep2b(){
      if(!getEffectiveRole()) return false;
      // Dinglich Berechtigte werden derzeit nicht bearbeitet
      if(state.rolePriv === 'self-dinglich'){ dinglichPruefen(); return false; }
      return true;
    }
    function validateStep3(){
      var ok = true;
      // Dinglich Berechtigte werden derzeit nicht bearbeitet
      if(!dinglichPruefen()) return false;
      var visible = document.querySelector('[data-data-block].im-show');
      if(!visible){
        // priv-self-owner skips step 3 (no required fields) — treat as valid
        if(state.group==='private' && getEffectiveRole()==='self-owner') return true;
        return false;
      }
      visible.querySelectorAll('input[type="text"],input[type="email"],select').forEach(function(el){
        // Felder in versteckten im-cond-Containern überspringen
        var hiddenParent = el.closest('.im-cond:not(.im-show)');
        if(hiddenParent && hiddenParent !== visible) return;
        // Find associated label: either via 'for' attribute, parent <label>, or previousSibling
        var lbl = null;
        if(el.id){
          lbl = visible.querySelector('label[for="'+el.id+'"]');
        }
        if(!lbl){
          // Look at previous siblings — find the closest <label>
          var sib = el.previousElementSibling;
          while(sib && sib.tagName !== 'LABEL'){ sib = sib.previousElementSibling; }
          lbl = sib;
        }
        if(!lbl){
          // Look up the .im-fg ancestor and find its label
          var fg = el.closest('.im-fg');
          if(fg) lbl = fg.querySelector('label');
        }
        // Required if label contains an asterisk
        var isRequired = lbl && lbl.textContent.indexOf('*') !== -1;
        if(isRequired){
          clearError(el);
          if(!el.value || !el.value.trim()){ setError(el, 'Pflichtfeld'); ok = false; }
        }
      });
      // Vertretungsbefugnis radios for comp-organ
      if(state.group==='company' && state.roleComp==='organ'){
        if(!state.compVertretung){ ok = false; }
      }
      return ok;
    }
    /* ---------- Nachweis-Hidden-Felder bereinigen ----------
       Drei der vier Datei-Felder tragen denselben Property-Namen
       (properties[Vollmacht oder Erbschein]). Das Nachweis-Skript legt für
       jedes Feld ein eigenes Hidden-Input an, also gehen bis zu drei
       gleichnamige Felder mit in die Bestellung. Von gleichnamigen Feldern
       behält Shopify eines — ein leeres Feld aus einem gar nicht sichtbaren
       Block kann so die Vorgangsnummer des tatsächlich hochgeladenen
       Nachweises überschreiben. Dann ist der Upload erfolgreich, in den
       Bestelldetails steht aber nichts, und die Datei lässt sich der
       Bestellung nicht mehr zuordnen.

       Deshalb wird vor dem Absenden alles abgeschaltet, was nicht zum
       sichtbaren Block gehört oder leer ist. Deaktivierte Felder nimmt
       FormData nicht auf, es bleibt genau ein Feld je Property-Name übrig.
       Die Sichtbarkeitsprüfung entspricht der aus validateStep4. */
    function nachweisFelderBereinigen(){
      var sichtbar   = document.querySelector('[data-proof-block].im-show');
      var unterblock = sichtbar && sichtbar.querySelector('[data-vollmacht-block].im-show, [data-erbe-vm-block].im-show');

      document.querySelectorAll('input[id$="-nachweis-id"]').forEach(function(hidden){
        var datei = document.getElementById(hidden.id.replace(/-nachweis-id$/, ''));
        var aktiv = !!(hidden.value && datei && sichtbar && sichtbar.contains(datei));

        // Liegt das Feld in einem Unterblock (Vollmacht vorhanden / Erbe-
        // Vollmacht vorhanden), zählt nur der gerade aufgeklappte.
        if(aktiv){
          var eigenerUnterblock = datei.closest('[data-vollmacht-block], [data-erbe-vm-block]');
          if(eigenerUnterblock) aktiv = (eigenerUnterblock === unterblock);
        }

        hidden.disabled = !aktiv;
      });
    }

    function validateStep4(){
      var ok = true;
      var visible = document.querySelector('[data-proof-block].im-show');
      if(!visible) return true;

      // Check Vollmacht radio selection if vollmacht block is active
      var blockType = visible.getAttribute('data-proof-block');
      if(blockType === 'vollmacht'){
        if(!state.vollmachtStatus){
          ok = false;
          // Highlight the radio group
          var rs = visible.querySelector('.im-radio-stack');
          if(rs && !pruefungStumm) rs.classList.add('im-error');
        }
      }
      if(blockType === 'erbe-rep'){
        if(!state.erbeVm){ ok = false; }
      }

      // Wenn 'brauchen' gewählt: harter Stop — kein Weiter möglich
      if(blockType === 'vollmacht' && state.vollmachtStatus === 'brauchen'){ return false; }
      if(blockType === 'erbe-rep' && state.erbeVm === 'brauchen'){ return false; }

      // Only validate file inputs in the visible sub-block
      // (vollmacht-status='haben' or erbe-vm='haben' shows upload, otherwise no file required)
      var activeSubBlock = visible.querySelector('[data-vollmacht-block].im-show, [data-erbe-vm-block].im-show');
      // For erbe-self, the block has the file directly (no sub-block)
      var fileSearchScope = activeSubBlock || visible;

      // For erbe-rep: ALSO check the erbschein file (always required)
      if(blockType === 'erbe-rep'){
        var erbschein = visible.querySelector('input[type="file"]#im-erbschein-rep-input');
        if(erbschein){
          clearError(erbschein);
          // value statt files: gefüllt erst nach erfolgreichem Upload
          if(!erbschein.value){
            var drop1 = erbschein.closest('.im-file-drop');
            if(drop1 && !pruefungStumm) drop1.classList.add('im-error');
            ok = false;
          }
        }
      }

      // Check files in active sub-block / direct block
      fileSearchScope.querySelectorAll('input[type="file"]').forEach(function(f){
        // Skip the erbschein-rep one (already checked above)
        if(f.id === 'im-erbschein-rep-input') return;
        clearError(f);
        // value statt files: gefüllt erst nach erfolgreichem Upload
        if(!f.value){
          var drop = f.closest('.im-file-drop');
          if(drop && !pruefungStumm) drop.classList.add('im-error');
          ok = false;
        }
      });

      return ok;
    }
    function validateStep5(){
      var ok = true;
      var agb = document.getElementById('im-cb-agb');
      var wid = document.getElementById('im-cb-widerruf');
      var legalErr = document.getElementById('im-legal-error');
      var allChecked = (agb && agb.checked) && (wid && wid.checked);
      if(!pruefungStumm){
        if(legalErr){ if(allChecked) legalErr.setAttribute('hidden',''); else legalErr.removeAttribute('hidden'); }
        [agb, wid].forEach(function(cb){
          if(!cb) return;
          var lbl = cb.closest('.im-legal-cb');
          if(lbl){
            if(cb.checked) lbl.classList.remove('im-error');
            else lbl.classList.add('im-error');
          }
        });
      }
      if(!allChecked) ok = false;
      return ok;
    }

    /* ---------- Sichtbare Felder in die Brücke übernehmen ----------
       Mehrere Eingabefelder teilen sich einen Property-Namen: "Vertretener:
       Name" gibt es zweimal (Privatperson-Vertreter und Erben-Vertreter),
       "Eigentümer: Name" viermal. Maßgeblich ist immer das Feld der gerade
       gewählten Konstellation. Ein Wert aus einem ausgeblendeten Block ist
       der Rest einer verworfenen Auswahl und gehört nicht in die Bestellung. */
    function feldAktiv(el){
      var c = el.closest('.im-cond');
      while(c){
        if(!c.classList.contains('im-show')) return false;
        c = c.parentElement ? c.parentElement.closest('.im-cond') : null;
      }
      return true;
    }

    function uebernehmeFelder(){
      var belegt = {};
      // 1. Durchgang: Felder der gewählten Konstellation — sie entscheiden,
      //    auch wenn sie leer sind (dann wird ein alter Wert überschrieben).
      document.querySelectorAll('[data-property]').forEach(function(el){
        if(!feldAktiv(el)) return;
        var p = el.getAttribute('data-property');
        if(belegt[p]) return;
        setHiddenProperty(p, el.value);
        belegt[p] = true;
      });
      // 2. Durchgang: Properties ohne aktives Feld unangetastet lassen, aber
      //    einen vorhandenen Wert nachtragen, falls die Brücke leer ist.
      document.querySelectorAll('[data-property]').forEach(function(el){
        var p = el.getAttribute('data-property');
        if(belegt[p] || !el.value) return;
        setHiddenProperty(p, el.value);
        belegt[p] = true;
      });
    }

    /* Vollständige Prüfung ohne sichtbare Fehlermarkierungen. */
    function alleFelderOk(){
      pruefungStumm = true;
      try { return validateAll(); }
      finally { pruefungStumm = false; }
    }

    function validateAll(){
      uebernehmeFelder();
      computeAndSetHiddenProperties();
      var ok1 = validateStep1();
      var ok2a = validateStep2a();
      var ok2b = validateStep2b();
      var ok3 = validateStep3();
      var ok4 = needsProofStep() ? validateStep4() : true;
      var ok5 = validateStep5();
      return ok1 && ok2a && ok2b && ok3 && ok4 && ok5;
    }
    window.immofilesValidateAll = validateAll;

    /* ---------- PayPal Express: vollständige Prüfung ----------
       Frühere Annahme: Wer Schritt 5 erreicht, hat alle Pflichtfelder
       ausgefüllt, also genügt hier die Prüfung von AGB und Widerruf.
       Die Annahme traegt nicht. Bestellung IM275126 kam über PayPal herein
       mit "Vertreter mit Vollmacht", aber ohne Namen und ohne Rolle der
       vertretenen Person — beides Pflichtfelder aus Schritt 3. Über den
       Warenkorb-Knopf wäre das nicht passiert: dort prüft der Submit-Guard
       validateAll(). PayPal Express löst kein submit-Ereignis aus, also lief
       dort nur die Prüfung der beiden Häkchen.

       Ein fehlender Eigentümername ist nicht nachträglich zu heilen: Ohne ihn
       lässt sich der Auszug nicht abrufen und die Vollmacht nicht erzeugen.
       Deshalb prüft der Wächter jetzt alles — stumm, damit niemand rote
       Felder in Schritten sieht, die er noch nicht geöffnet hat. */
    /* Springt zum ersten unvollständigen Schritt und markiert ihn — wird
       aufgerufen, wenn jemand auf den gesperrten PayPal-Knopf klickt.
       Ohne diesen Sprung stünde der Kunde vor einem Knopf, der nicht
       reagiert, und wüsste nicht, warum. */
    function zeigeErstenFehler(){
      var pruefungen = [
        [1,    validateStep1],
        ['2a', validateStep2a],
        ['2b', validateStep2b],
        [3,    validateStep3],
        [4,    function(){ return needsProofStep() ? validateStep4() : true; }],
        [5,    validateStep5]
      ];
      for(var i = 0; i < pruefungen.length; i++){
        if(pruefungen[i][1]()) continue;
        var ziel = pruefungen[i][0];
        if(ziel !== 5) goStep(ziel);
        var fehler = document.querySelector('.im-step.im-active .im-error, .im-step.im-active .im-field-error');
        if(fehler){
          var r = fehler.getBoundingClientRect();
          window.scrollTo({ top: r.top + window.pageYOffset - 100, behavior: 'smooth' });
        }
        return false;
      }
      return true;
    }

    function appendExternalPropertyInputsToFormData(form, formData) {
      if (!form || !formData) return;
      var selector =
        'input[name^="properties["][form], ' +
        'select[name^="properties["][form], ' +
        'textarea[name^="properties["][form]';
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.disabled) return;
        if (!el.name) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        formData.set(el.name, el.value || '');
      });
    }

    /* ---------- Submit guard ----------
       Das im-cart-form ist jetzt ein Dawn product-form mit data-type="add-to-cart-form".
       Dawn's product-form.js Custom Element übernimmt fetch + Cart Drawer + Cookies.
       Wir laufen im capturing-Phase davor: Properties syncen, validieren,
       Hidden-Inputs ins Form verschieben, dann Submit durchlassen. */
    document.querySelectorAll('form.im-cart-form').forEach(function(form){
      form.addEventListener('submit', function(e){

        // 1) Properties berechnen und syncen
        uebernehmeFelder();
        computeAndSetHiddenProperties();

        // 2) Validierung — bei Fehler abbrechen und Dawn stoppen
        if(!validateAll()){
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          var firstErr = document.querySelector('.im-error, .im-field-error, .im-legal-cb.im-error, .im-file-drop.im-error');
          if(firstErr){
            var rect = firstErr.getBoundingClientRect();
            window.scrollTo({top: rect.top + window.pageYOffset - 100, behavior: 'smooth'});
          }
          return false;
        }

        // 3) Nochmal compute/sync nach Validierung (Race-Condition-Schutz)
        uebernehmeFelder();
        computeAndSetHiddenProperties();

        // 4) Hidden-Inputs physisch ins Form verschieben — erst nach validateAll
        //    damit setHiddenProperty sie bis dahin noch im Container findet
        var hiddenContainer = document.querySelector('[id^="im-hidden-properties"]');
        if (hiddenContainer) {
          hiddenContainer.querySelectorAll('input[name^="properties["]').forEach(function(inp){
            form.appendChild(inp);
          });
        }

        // Nachweis-Hidden-Fields ebenfalls ins Form verschieben
        nachweisFelderBereinigen();
        document.querySelectorAll('input[id$="-nachweis-id"]').forEach(function(inp){
          if (inp.closest('form') !== form) {
            form.appendChild(inp);
          }
        });

        // 5) Debug-Log
        if (window.IMMOFILES_DEBUG) {
          console.group('[Immofiles] Submit — Properties im Form');
          form.querySelectorAll('input[name^="properties["]').forEach(function(el){
            console.log(el.name, '→', el.value);
          });
          console.groupEnd();
        }

        // 6) Submit durchlassen — Dawn's product-form.js übernimmt
      }, true);
    });




    /* ---------- PayPal Guard (simplified) ----------
       Old approach: iframe overlay div. Problems with positioning on hidden steps.
       Required wizard fields enforced by step navigation; only AGB+Widerruf left to check.
       Updated whenever a legal checkbox changes or step changes. */
    /* ---------- PayPal Guard — CSS-Klasse im-paypal-blocked ----------
       Blockiert PayPal Express bis AGB + Widerruf gecheckt sind. */
    function updatePayPalGuard() {
      var wrap = document.getElementById('im-paypal-wrap');
      if (!wrap) return;
      wrap.classList.toggle('im-paypal-blocked', !alleFelderOk());
    }

    // Klick auf den gesperrten Knopf: Die ::after-Fläche fängt ihn ab, hier
    // wird erklärt, woran es liegt.
    (function(){
      var wrap = document.getElementById('im-paypal-wrap');
      if (!wrap) return;
      wrap.addEventListener('click', function(e){
        if (!wrap.classList.contains('im-paypal-blocked')) return;
        e.preventDefault();
        e.stopPropagation();
        zeigeErstenFehler();
      }, true);
    })();

    // Nach einem Schrittwechsel erst prüfen, wenn die Sichtbarkeitsklassen
    // gesetzt sind — sonst beurteilt feldAktiv() den alten Zustand.
    function updatePayPalGuardSpaeter(){ setTimeout(updatePayPalGuard, 0); }

    // Jede Eingabe im Fragebogen kann den Wächter öffnen oder schließen.
    ['input','change'].forEach(function(art){
      document.addEventListener(art, function(e){
        if(!e.target || !e.target.closest) return;
        if(e.target.closest('.im-face-b')) updatePayPalGuardSpaeter();
      }, true);
    });

    function initPayPalGuard() { updatePayPalGuard(); return true; }
    function updateGuardPosition() {}

    updatePayPalGuard();

    document.addEventListener('change', function(e) {
      if (e.target && (e.target.id === 'im-cb-agb' || e.target.id === 'im-cb-widerruf')) {
        updatePayPalGuard();
        var agb = document.getElementById('im-cb-agb');
        var wid = document.getElementById('im-cb-widerruf');
        var legalErr = document.getElementById('im-legal-error');
        if (legalErr && agb && wid && agb.checked && wid.checked) {
          legalErr.setAttribute('hidden', '');
          [agb, wid].forEach(function(cb) {
            var lbl = cb.closest('.im-legal-cb');
            if (lbl) lbl.classList.remove('im-error');
          });
        }
      }
    });

    /* ---------- File drops (Upload über externes Nachweis-Skript) ---------- */

    function initFileDrop(drop){
      if(drop.dataset.imInitialized === '1') return;
      drop.dataset.imInitialized = '1';

      var input = drop.querySelector('input[type="file"]');
      var btn = drop.querySelector('.im-fd-btn');
      var name = drop.querySelector('.im-fd-filename');
      if(!input) return;
      input.style.pointerEvents = 'none';

      // Hinweis: Hidden-Feld, value-Umleitung und der Upload werden vom
      // externen immofiles-banner-nachweis.js erledigt.
      // Dieser Block steuert nur Klick-zum-Öffnen und die Dateinamenanzeige.
      if(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          input.click();
        });
      }
      drop.addEventListener('click', function(e){
        if(e.target === btn || (btn && btn.contains(e.target))) return;
        if(e.target === input) return;
        e.preventDefault(); e.stopPropagation();
        input.click();
      });

      input.addEventListener('change', function(){
        var file = input.files && input.files[0];
        if(!file){
          if(name){
            name.textContent = name.dataset.placeholder || 'Noch keine Datei ausgewählt';
            name.classList.remove('im-has-file');
          }
          drop.classList.remove('im-has-file');
          return;
        }

        // Nur Dateinamenanzeige — der Upload läuft über das externe
        // immofiles-banner-nachweis.js, das einen eigenen change-Listener
        // registriert und die Datei an n8n sendet.
        if(name){
          name.textContent = file.name;
          name.classList.add('im-has-file');
        }
        drop.classList.add('im-has-file');
        drop.classList.remove('im-error');
      });

      drop.addEventListener('dragover', function(e){ e.preventDefault(); drop.classList.add('im-dragover'); });
      drop.addEventListener('dragleave', function(e){ e.preventDefault(); drop.classList.remove('im-dragover'); });
      drop.addEventListener('drop', function(e){
        e.preventDefault();
        drop.classList.remove('im-dragover');
        if(e.dataTransfer.files && e.dataTransfer.files.length > 0){
          input.files = e.dataTransfer.files;
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
    }

    function initAllFileDrops(){
      document.querySelectorAll('.im-file-drop').forEach(initFileDrop);
    }

    // Init file drops (click-to-open, drag&drop, filename display)
    // Der eigentliche Upload läuft über immofiles-banner-nachweis.js
    initAllFileDrops();
    // Retry for late-rendered drops (e.g. if step 4 not visible yet)
    (function(){
      var attempts = 0;
      var retry = setInterval(function(){
        attempts++;
        initAllFileDrops();
        if(attempts > 20){ clearInterval(retry); }
      }, 500);
    })();
    // Zusätzlich sofort initialisieren
    initAllFileDrops();


    /* ---------- Legal checkbox styling ---------- */
    document.querySelectorAll('.im-legal-cb input[type="checkbox"]').forEach(function(cb){
      cb.addEventListener('change', function(){
        var lbl = cb.closest('.im-legal-cb');
        if(lbl){ if(cb.checked) lbl.classList.remove('im-error'); }
        var legalErr = document.getElementById('im-legal-error');
        var agb = document.getElementById('im-cb-agb');
        var wid = document.getElementById('im-cb-widerruf');
        if(agb && wid && agb.checked && wid.checked && legalErr){ legalErr.setAttribute('hidden',''); }
      });
    });

    /* ---------- Property bridge ---------- */
    function setHiddenProperty(name, value){
      document.querySelectorAll('[data-im-property]').forEach(function(el){
        if(el.getAttribute('data-im-property') === name){
          el.value = value || '';
        }
      });
    }

    function bindDataPropertyInputs(){
      document.querySelectorAll('[data-property]').forEach(function(el){
        var prop = el.getAttribute('data-property');
        function sync(){ setHiddenProperty(prop, el.value); }
        el.addEventListener('input', sync);
        el.addEventListener('change', sync);
        sync();
      });
    }

    function computeAndSetHiddenProperties(){
      // Antrag: Eingetragen
      var grpLabels = { private:'Privatperson(en)', company:'Unternehmen / Verein', estate:'Verstorbene Person' };
      setHiddenProperty('Antrag: Eingetragen', state.group ? grpLabels[state.group] : '');

      // Antrag: Rolle (human-readable) — über getRoleCategory() damit immer normalisierter Wert
      var role = getRoleCategory();
      var roleLabels = {
        'self':'Selbst Eigentümer / Miteigentümer',
        'self-owner':'Selbst Eigentümer / Miteigentümer',
        'self-dinglich':'Selbst dinglich Berechtigter',
        'rep-with':'Vertreter mit Vollmacht',
        'rep-without':'Vertreter ohne Vollmacht',
        'organ':'Organschaftlicher Vertreter',
        'external-with':'Externe Vertretung mit Vollmacht',
        'external-without':'Externe Vertretung ohne Vollmacht',
        'heir-self':'Erbe selbst',
        'heir-rep-with':'Vertreter eines Erben mit Vollmacht',
        'heir-rep-without':'Vertreter eines Erben ohne Vollmacht'
      };
      setHiddenProperty('Antrag: Rolle', role ? (roleLabels[role] || role) : '');

      // Antrag: Konstellation (combined string)
      var konst = '';
      if(state.group && role){
        konst = (grpLabels[state.group] || state.group) + ' / ' + (roleLabels[role] || role);
      }
      setHiddenProperty('Antrag: Konstellation', konst);

      // Vertretungsbefugnis
      if(state.group==='company' && state.roleComp==='organ'){
        var label = state.compVertretung==='single' ? 'Einzelvertretungsberechtigt' : (state.compVertretung==='joint' ? 'Gemeinsame Vertretung' : '');
        setHiddenProperty('Eingetragene Gesellschaft: Vertretungsbefugnis', label);
      } else {
        setHiddenProperty('Eingetragene Gesellschaft: Vertretungsbefugnis', '');
      }

      // Versand-Properties frisch berechnen (16-Uhr-Cutoff kann sich seit
      // Seitenaufruf geändert haben; wird u. a. beim Submit aufgerufen)
      updateDeliveryUI();
    }

    bindDataPropertyInputs();

    /* ---------- Aside summary ---------- */
    function syncAside(){
      var s = document.getElementById('im-sum-street');
      var c = document.getElementById('im-sum-city');
      var st = document.getElementById('im-sum-state');

      if(!state.hasAddress){
        // No-address mode: aside shows "Ohne Adresse" + Bundesland
        if(s) s.textContent = 'Ohne Adresse';
        if(c) c.textContent = '—';
        if(st) st.textContent = state.address.state || '—';
      } else {
        if(s) s.textContent = state.address.street || '—';
        if(c) c.textContent = (state.address.plz || '') + (state.address.plz && state.address.city ? ' ' : '') + (state.address.city || '') || '—';
        if(st) st.textContent = state.address.state || '—';
      }

      // Update address tag in wizard top bar (compact text)
      var addrText = document.getElementById('im-addr-text');
      if(addrText){
        if(!state.hasAddress){
          addrText.textContent = 'Objekt ohne Adresse' + (state.address.state ? ' · ' + state.address.state : '');
        } else {
          var parts = [];
          if(state.address.street) parts.push(state.address.street);
          var cityPart = '';
          if(state.address.plz) cityPart += state.address.plz;
          if(state.address.city) cityPart += (cityPart ? ' ' : '') + state.address.city;
          if(cityPart) parts.push(cityPart);
          addrText.textContent = parts.length ? parts.join(', ') : '—';
        }
      }

      var appBlock = document.getElementById('im-sum-applicant');
      var grpLabels = { private:'Privatperson(en)', company:'Unternehmen / Verein', estate:'Verstorbene Person' };
      var roleLabels = {
        'self-owner':'Selbst Eigentümer','self-dinglich':'Selbst dinglich Berechtigter',
        'vertreter':'Vertreter',
        'organ':'Organschaftlich','external':'Extern (mit Vollmacht)',
        'heir-self':'Erbe selbst','heir-rep':'Vertreter eines Erben'
      };
      if(state.group){
        if(appBlock) appBlock.removeAttribute('hidden');
        var grpEl = document.getElementById('im-sum-grp');
        if(grpEl) grpEl.textContent = grpLabels[state.group] || '—';
        var role = getEffectiveRole();
        var rl = document.getElementById('im-sum-role-line');
        if(role){
          if(rl) rl.removeAttribute('hidden');
          var rEl = document.getElementById('im-sum-role');
          if(rEl) rEl.textContent = roleLabels[role] || role;
        } else {
          if(rl) rl.setAttribute('hidden','');
        }
      } else {
        if(appBlock) appBlock.setAttribute('hidden','');
      }
    }

    /* ---------- Next-card toggle ---------- */
    var ncBtn = document.getElementById('im-nc-head-btn');
    if(ncBtn){
      ncBtn.addEventListener('click', function(){
        var card = document.getElementById('im-next-card');
        if(!card) return;
        var expanded = card.getAttribute('aria-expanded') !== 'false';
        card.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        ncBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        card.setAttribute('data-user-toggled', '1');
        var lbl = card.querySelector('.im-nc-toggle-txt');
        if(lbl) lbl.textContent = expanded ? 'Details' : 'Schließen';
      });
    }

    function initNextCardState(){
      var card = document.getElementById('im-next-card');
      if(!card) return;
      if(card.hasAttribute('data-user-toggled')) return;
      var isMobile = window.matchMedia('(max-width: 600px)').matches;
      card.setAttribute('aria-expanded', isMobile ? 'false' : 'true');
      var btn = card.querySelector('.im-nc-head-btn');
      if(btn) btn.setAttribute('aria-expanded', isMobile ? 'false' : 'true');
      var lbl = card.querySelector('.im-nc-toggle-txt');
      if(lbl) lbl.textContent = isMobile ? 'Details' : 'Schließen';
    }
    window.addEventListener('resize', function(){
      var card = document.getElementById('im-next-card');
      if(card){ card.removeAttribute('data-user-toggled'); initNextCardState(); }
    });

    /* ---------- Initial setup ---------- */
    bindDatepickers();
    bindStep4Radios();
    checkStateAvailability();
    syncAside();
    updateProgressBar();

    // Show step 1 by default in the wizard pane (still hidden behind face-a until user searches)
    goStep(1);
  }

    /* ---------- bfcache-Fix ----------
       Bei Seitenneuladen aus Cache: AGB/Widerruf zurücksetzen → Guard sperrt PayPal. */
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        var agb = document.getElementById('im-cb-agb');
        var wid = document.getElementById('im-cb-widerruf');
        if (agb) agb.checked = false;
        if (wid) wid.checked = false;
          }
    });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
